import { createSlice } from '@reduxjs/toolkit';
import HbsCihaztanimDTO from 'src/models/RadyolojiModul/HbsCihaztanimDTO';
import VwCihaztestDTO from 'src/models/RadyolojiModul/VwCihaztestDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';

// 1
interface RadyolojiCihazTestTanimState {
  seciliCihaz: HbsCihaztanimDTO;
  cihazIslemleri: Array<VwCihaztestDTO>;
  cihazIslemleriRefetchTrigger: boolean;
}

// 2
const initialState: RadyolojiCihazTestTanimState = {

  seciliCihaz: null,
  cihazIslemleri: [],
  cihazIslemleriRefetchTrigger: false
}

// 3
const RadyolojiCihazTestTanimReducers = {
  setSeciliCihaz: (state: RadyolojiCihazTestTanimState, action) => {
    state.seciliCihaz = action.payload;
  },
  setCihazIslemleri: (state: RadyolojiCihazTestTanimState, action) => {
    state.cihazIslemleri = action.payload;
  },
  setCihazIslemleriRefetchTrigger: (state: RadyolojiCihazTestTanimState, action) => {
    state.cihazIslemleriRefetchTrigger = action.payload;
  },
}

const RadyolojiCihazTestTanimSlice = createSlice<RadyolojiCihazTestTanimState, MapReducerPayloads<RadyolojiCihazTestTanimState, {
  // 4
  setSeciliCihaz: HbsCihaztanimDTO,
  setCihazIslemleri: Array<VwCihaztestDTO>,
  setCihazIslemleriRefetchTrigger: boolean
}>>({
  name: 'radyolojiCihazTestTanim',
  initialState,
  reducers: RadyolojiCihazTestTanimReducers,
})

export default RadyolojiCihazTestTanimSlice;
